function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import Tag from "segments/desktop/core-components/tag/tag";
import { StyledTagItemsGridComponent } from "./tag-items-grid-component.scss";
const TagItemsGridComponent = (props)=>{
    const { gridTags = [], width, gridTagsBackgroundColor, gridTagsImageHeight, noImageWidth, tagTextSize } = props;
    const renderTag = (gridTag, index)=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "grid-tag-wrapper",
            children: /*#__PURE__*/ _jsx(Tag, _object_spread_props(_object_spread({}, gridTag), {
                tagBackgroundColor: gridTagsBackgroundColor,
                tagImageHeight: gridTagsImageHeight,
                noImageWidth: noImageWidth,
                tagTextSize: tagTextSize
            }))
        }, index);
    };
    return /*#__PURE__*/ _jsx(StyledTagItemsGridComponent, {
        className: "tag-items-grid-component",
        style: {
            width
        },
        children: gridTags.map(renderTag)
    });
};
TagItemsGridComponent.defaultProps = {
    paddingTop: "16px",
    paddingBottom: "16px",
    gridTags: [
        {
            tagText: "Projects",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Projects_icon_circle.png"
        },
        {
            tagText: "Marketing",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Marketing_icon_circle.png"
        },
        {
            tagText: "CRM",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/CRM_icon_circle.png"
        },
        {
            tagText: "Software",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/software_icon_circle.png"
        },
        {
            tagText: "Creative & design",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Creative_design_icon_circle.png"
        },
        {
            tagText: "HR",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/HR_icon_circle.png"
        },
        {
            tagText: "Operations",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Operations_icon_circle.png"
        },
        {
            tagText: "IT",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/IT_icon_circle.png"
        },
        {
            tagText: "200+ workflows",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/200_workflows_icon_circle.png"
        }
    ]
};
export default TagItemsGridComponent;
